import React from "react";
import "./Chips.css";

/* Neutral gray for zero, blue for any positive quantity — no arbitrary
   coloring, and no amber "high quantity" tier since no business
   threshold for that exists today. */
export default function QtyBadge({ value }) {
  const qty = Number(value);
  const hasQty = Number.isFinite(qty) && qty > 0;
  const family = hasQty ? "chip-blue" : "chip-neutral";

  return (
    <span className={`chip qty-badge ${family}`}>
      {Number.isFinite(qty) ? qty : value ?? 0}
    </span>
  );
}
